import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../root/config.store";
import { PhotoUploadPayload, ValidateTokenPayload, initialState } from "../../types/photoUpload";

// Post Slice
export const photoUploadSlice = createSlice({
  name: "photoUpload",
  initialState,
  reducers: {
    submitPhotoUpload(state, action: PayloadAction<PhotoUploadPayload>) {
      state.photoUploadData = action.payload;
      state.success = false;
      state.loading = true;
      state.error = null;
    },
    submitPhotoUploadSuccess(state, action: PayloadAction<PhotoUploadPayload>) {
      state.photoUploadData = action.payload;
      state.error = null;
      state.loading = false;
      state.success = true;
    },
    submitPhotoUploadFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPhotoUploadState(state) {
      state.photoUploadData = null;
      state.success = false;
      state.error = null;
      state.loading = false;
    },
    validateToken(state, action: PayloadAction<ValidateTokenPayload>) {
      state.validateTokenData = action.payload;
      state.success = false;
      state.loading = true;
      state.error = null;
    },
    submitValidateTokenSuccess(state, action: PayloadAction<ValidateTokenPayload>) {
      state.validateTokenData = action.payload;
      state.error = null;
      state.loading = false;
      state.success = true;
    },
    submitValidateTokenFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Actions
export const photoUploadActions = {
  submitPhotoUploadStart: photoUploadSlice.actions.submitPhotoUpload,
  submitPhotoUploadSuccess: photoUploadSlice.actions.submitPhotoUploadSuccess,
  submitPhotoUploadFailure: photoUploadSlice.actions.submitPhotoUploadFailure,
  resetPhotoUploadState: photoUploadSlice.actions.resetPhotoUploadState,
  validateToken: photoUploadSlice.actions.validateToken,
  submitValidateTokenSuccess: photoUploadSlice.actions.submitValidateTokenSuccess,
  submitValidateTokenFailure: photoUploadSlice.actions.submitValidateTokenFailure,
};

// Selectors
export const selectValidateToken = (state: RootState): ValidateTokenPayload =>
  state.photoUpload?.data;

// Selectors
export const selectPhotoUpload = (state: RootState): PhotoUploadPayload =>
  state.photoUpload?.data;

// Reducer
export default photoUploadSlice.reducer;
